import './AppFooter.css';

export default function AppFooter({ requestId }) {
  return (
    <footer className="app-footer">
      <span>DEBUNKED! / FORENSIC PHOTO CREDIBILITY · NOT LEGAL EVIDENCE</span>
      <span className="app-footer__req">{requestId ? `REQ ${requestId}` : 'REQ ——'}</span>
    </footer>
  );
}
